import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from '../auth';

/** Registra interação na API (accessDates no usuário; backend aplica intervalo de 12h). */
@Injectable({
  providedIn: 'root',
})
export class UserActivityService {
  private touching = false;

  constructor(
    private readonly http: HttpClient,
    private readonly authService: AuthService,
  ) {}

  static isPlatformApiUrl(url: string): boolean {
    if (!url) {
      return false;
    }
    return (
      url.includes(environment.apiUrl)
      || url.includes(environment.apiFamilyUrl)
      || url.includes(environment.apiAssetsUrl)
    );
  }

  touchIfAuthenticated(): void {
    const user = this.authService.getAuthFromLocalStorage();
    if (!user?.token || !user?.id || this.touching) {
      return;
    }
    if (urlHasStaffToken()) {
      return;
    }
    this.touching = true;
    this.http.post(
      `${environment.apiUrl}/users/me/activity`,
      {},
      {
        headers: new HttpHeaders({
          token: `${user.token}`,
          id: `${user.id}`,
        }),
      },
    ).subscribe({
      complete: () => {
        this.touching = false;
      },
      error: () => {
        this.touching = false;
      },
    });
  }
}

function urlHasStaffToken(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  const params = new URLSearchParams(new URL(window.location.href).search);
  return !!params.get('token');
}
